import script from "./ReservationImpossibleXL.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationImpossibleXL.vue?vue&type=script&setup=true&lang=js"

import "./ReservationImpossibleXL.vue?vue&type=style&index=0&id=487aed46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487aed46"]])

export default __exports__